module.exports = __webpack_public_path__ + "img/two-o'clock.86c981b1.png";